module.exports = __webpack_public_path__ + "assets/img/info@1,5x.26d7a513.svg";